import { Controller, useFormContext } from "react-hook-form";

import { loadLocale } from "@smart/itops-locale-dom";
import { RadioButtons } from "@smart/itops-sb-design-system-dom";

export const BackgroundColor = ({ disabled }: { disabled?: boolean }) => {
  const { control } = useFormContext();
  const locale = loadLocale();
  const colorTerm = locale.terms.colour;

  return (
    <div className="flex flex-col gap-[1.2rem]">
      <div className="text-paragraph font-semibold">
        Background {colorTerm.header}
      </div>
      <Controller
        control={control}
        name="backgroundColor"
        render={({ field }) => (
          <RadioButtons
            options={[
              { label: "Default", value: "default" },
              { label: `Brand ${colorTerm.header}`, value: "brandColor" },
              { label: "White", value: "white" },
              { label: "Transparent", value: "transparent" },
            ]}
            value={field.value}
            onChange={(value) => field.onChange(value)}
            disabled={disabled}
            className="text-ui"
          />
        )}
      />
    </div>
  );
};
